module.exports = __webpack_public_path__ + "img/wp-new-habit-card23.67f1623b.png";